<template>
  <!-- 轨迹控制器 组件 -->
  <div class="trail-container" :class="external ? 'external' : ''">
    <!-- 标题栏 -->
    <div class="header">
      <h2 class="trail-title">
        {{ $t('GPS_BD') }} {{ $t('trackLine') }}
        <el-tooltip class="item" :effect="isDefaultTheme ? 'light' : 'dark'" placement="bottom">
          <div slot="content">
            <p>{{ $t('trackStylDescription') }}</p>
            <p>
              1. <span style="color:#00f2a9;">{{ $t('greensolidLine') }}</span>
              <span>：{{ $t('speedMovement') }}{{ $t('lessThan') }} 20 km/h；</span>
            </p>
            <p>
              2. <span style="color:#ffdd3e;">{{ $t('yellowsolidLine') }}</span>
              <span>：{{ $t('speedMovement') }}{{ $t('uatedBetween') }} 20 km/h 至 60 km/h；</span>
            </p>
            <p>
              3. <span style="color:#ff762b;">{{ $t('rangesolidLine') }}</span>
              <span>：{{ $t('speedMovement') }}{{ $t('greaterThan') }} 60 km/h；</span>
            </p>
            <p>
              4. <span style="color:#da69fa;">{{ $t('pinksolidLine') }}</span>
              <span>：{{ $t('receivedAssist') }}</span>
            </p>
          </div>
          <i class="help_icon"></i>
        </el-tooltip>
      </h2>
      <!-- 调式使用，可手动打开展示 -->
      <el-tooltip v-show="false">
        <div slot="content">
          {{ trailQuery }}
        </div>
        <span>行号：{{ listTrackIndex + 1 }} / {{ listTrack.length }} 页号：{{ pageNum }} / {{ trailTotal }}</span>
      </el-tooltip>
      <i class="sys-close-btn" @click="closeWin"></i>
    </div>
    <div class="main" id="contentTrack">
      <!-- 滚动条 -->
      <DragProgress
        :show-text="false"
        :percent.sync="percent"
        @percentChange="percentChange"
        :showSlider="false"
        :width="width"
        :sliderWidth="0"
      ></DragProgress>
      <span class="play-time">{{ playTime | datetime }}</span>
      <!-- 滚动条描述信息 -->
      <div class="desc">
        <span class="start">{{ startTime | datetime }}</span>
        <span class="speed">x {{ speed }}</span>
        <span class="end">{{ endTime | datetime }}</span>
      </div>
      <!-- 控制按钮 -->
      <div class="btn-group">
        <el-button
          :class="hasPlay ? 'disab-btn' : 'allow-btn'"
          class="btn"
          :title="$t('toReplay')"
          @click="refresh"
          :disabled="hasPlay"
        >
          <img src="@/icon/monitor/refresh.png" />
        </el-button>
        <el-button
          v-if="!showDataCenter"
          :class="hasPlay ? 'disab-btn' : 'allow-btn'"
          class="btn"
          :title="$t('thePrevious')"
          @click="before"
          :disabled="hasPlay"
        >
          <img src="@/icon/monitor/before.png" />
        </el-button>
        <el-button
          :class="hasPlay ? 'disab-btn' : 'allow-btn'"
          class="btn"
          :title="$t('decelerate')"
          @click="reduction"
          :disabled="hasPlay"
        >
          <img src="@/icon/monitor/reduction.png" />
        </el-button>
        <el-button
          :class="hasPlay ? 'disab-btn' : 'allow-btn'"
          v-if="playing"
          class="btn"
          :title="$t('suspend')"
          @click="pause"
          :disabled="hasPlay"
        >
          <img src="@/icon/monitor/pause.png" />
        </el-button>
        <el-button
          :class="hasPlay ? 'disab-btn' : 'allow-btn'"
          v-else
          class="btn"
          :title="$t('play')"
          @click="play"
          :disabled="hasPlay"
        >
          <img src="@/icon/monitor/play.png" />
        </el-button>
        <el-button
          :class="hasPlay ? 'disab-btn' : 'allow-btn'"
          class="btn"
          :title="$t('accelerate')"
          @click="quicken"
          :disabled="hasPlay"
        >
          <img src="@/icon/monitor/quicken.png" />
        </el-button>
        <el-button
          v-if="!showDataCenter"
          :class="hasPlay ? 'disab-btn' : 'allow-btn'"
          class="btn"
          :title="$t('next')"
          @click="next"
          :disabled="hasPlay"
        >
          <img src="@/icon/monitor/next.png" />
        </el-button>
        <el-button
          :class="hasPlay ? 'disab-btn' : 'allow-btn'"
          class="btn"
          :title="$t('showEntireTrack')"
          @click="list"
          :disabled="hasPlay"
        >
          <img src="@/icon/monitor/list.png" />
        </el-button>
        <!-- 仅旧版界面展示视频播放控制图标 -->
        <template v-if="!newStyle">
          <el-button class="video-btn" @click="playVideo" :disabled="hasPlay" v-if="hasVideo">
            <img src="@/icon/gk_vidicon_on.png" />
          </el-button>
          <el-button class="video-btn" :disabled="true" v-else>
            <img src="@/icon/gk_vidicon_off.png" />
          </el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import DragProgress from '@/components/dragProgress/Index.vue'
import { listGpsDetail } from '@/api/log/gps'
import { traceLocation } from '@/api/monitor'
import { listMediasTag } from '@/api/log/mediaTag'
import { datetimeFull, datetimeFullZero, timeFilter } from '@/api/common'
import { formatDate, formatTime } from '@/util/date'
import { getLastCreateMap, initVectorLayer, addPolyline, addHelmet, setMapCenter, transformatPoint } from '@/common/map'
import { getDistance } from 'ol/sphere'
import { deepClone } from '@/util/common'
import { listGps } from '@/api/log/log'
import { Feature } from 'ol'
import { LineString, Point } from 'ol/geom'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style'
import { mapGetters } from 'vuex'

// 地图，在这里赋值避免双向绑定
let map
// 轨迹 图层
let vectorTrackLayer = null
// 预加载灰色轨迹 图层
let vectorPreLayer = null
// 头盔实时位置 图层
let currentHelmetLayer = null
// 当前绘制的轨迹线段，新的点直接加到这里
let currentLine = null
// 记录当前线样式，若新点的样式不通则需要创建一条新的LineString
let currentLineStyle = ''
export default {
  name: 'TrackController',
  props: {
    // 轨迹信息接口查询信息
    listTrack: {
      type: Array,
    },
    // 轨迹播放的  index
    listTrackIndex: {
      type: Number,
      default: 0,
    },
    // {startTimestamp:'', endTimestamp:'', userId:''}
    item: {
      type: Object,
      default: () => [],
    },
    // 展示轨迹视频
    showTrackVideo: {
      type: Boolean,
      default: false,
    },
    trailPageNum: {
      type: Number,
      default: 1,
    },
    trailTotal: {
      type: Number,
      default: 0,
    },
    trailQuery: {
      type: Object,
      default: () => {},
    },
    // 新版界面样式
    newStyle: {
      type: Boolean,
      default: false,
    },
    external: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DragProgress,
  },
  data() {
    return {
      playing: true,
      // 播放倍速，一倍速为2分钟每秒
      speed: 1.0,
      // 开始时间
      startTime: null,
      // 结束时间
      endTime: null,
      // 全部轨迹
      currentTrackPoints: [],
      // 当前绘制index
      drawPointIndex: 0,
      pointArr: [],
      // 播放进度条展示时间
      playTime: null,
      // 播放百分比
      percent: 0,
      // 播放轨迹定时器
      playInterval: null,
      // 当前读取的轨迹
      gpsTemp: [],
      hasVideo: false,
      // 用于查询当天录像
      logTimesBegin: '',
      logTimesEnd: '',
      // 时间段录像列表
      videoList: [],
      // 当前轨迹时间 录像
      videoData: [],
      hasPlay: false,
      // 调整播放速度
      setInterTime: 450,
      setSpeedTime: 20,
      // 轨迹播放 时间段的视频
      excludeList: [],
      secondTime: 0,
      clickPersent: 0,
      pageNum: 1,
      width: 0,
      // 请求的轨迹数据
      dataItem: {},
      showDataCenter: false,
    }
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化播放轨迹、时间、 进度条
    async init() {
      this.showDataCenter = false
      map = getLastCreateMap()
      // 预加载灰色轨迹
      vectorPreLayer = initVectorLayer(map, 'vectorPreLayer')
      // 轨迹
      vectorTrackLayer = initVectorLayer(map, 'vectorTrackLayer')
      // 头盔实时位置
      currentHelmetLayer = initVectorLayer(map, 'currentHelmetLayer')
      // 重置地图相关的一些属性
      this.resetMapAttr()
      this.clearPlayInterval()
      this.width = document.getElementById('contentTrack').offsetWidth
      let trailDetail = this.listTrack[this.listTrackIndex]
      if (trailDetail) {
        await this.getCurrentTrackPoints(() => {
          if (this.currentTrackPoints.length === 0) {
            console.error('当前轨迹无数据')
          } else {
            // 绘制预加载轨迹 #999灰色实线
            addPolyline(vectorPreLayer, this.currentTrackPoints, '#999', 'solid')
          }
        })
        if (
          trailDetail.startTimestamp ||
          trailDetail.specType === 1 ||
          trailDetail.specType === 2 ||
          trailDetail.specType === 3
        ) {
          if (trailDetail.startTimestamp) {
            this.logTimesBegin = datetimeFullZero(trailDetail.startTimestamp)
            this.logTimesEnd = datetimeFull(trailDetail.startTimestamp)
            // 开始结束时间
            this.startTime = dayjs(trailDetail.startTimestamp)
            this.endTime = dayjs(trailDetail.endTimestamp)
          } else if (trailDetail.logTimestamp) {
            this.showDataCenter = true
            // 数据中心数据形式不一样，需要特殊处理
            this.logTimesBegin = datetimeFullZero(trailDetail.logTimestamp)
            this.logTimesEnd = datetimeFull(trailDetail.logTimestamp)
            // 开始结束时间
            this.startTime = dayjs(trailDetail.logTimestamp)
            console.log(this.startTime, this.dataItem.endTimestamp, 'this.startTime')
            this.endTime = dayjs(this.dataItem.endTimestamp)
          }
          this.getTrackVideos()
          this.playTime = this.startTime
          this.calcTrack()
          // 根据deviceId判断是否为智能帽裎轨迹
        } else if (trailDetail.deviceId || trailDetail.specType === 4 || trailDetail.specType === 0) {
          if (trailDetail.beginTime) {
            this.logTimesBegin = datetimeFullZero(trailDetail.beginTime)
            this.logTimesEnd = datetimeFull(trailDetail.beginTime)
            // 开始结束时间，因为轨迹以分钟结尾，所以结束时间需加上59秒
            this.startTime = dayjs(trailDetail.beginTime)
            this.endTime = dayjs(trailDetail.endTime + ':59')
          } else if (trailDetail.logTimestamp) {
            // 数据中心数据形式不一样，需要特殊处理
            this.logTimesBegin = datetimeFullZero(trailDetail.logTimestamp)
            this.logTimesEnd = datetimeFull(trailDetail.logTimestamp)
            this.showDataCenter = true
            // 开始结束时间，因为轨迹以分钟结尾，所以结束时间需加上59秒
            this.startTime = dayjs(trailDetail.logTimestamp)
            this.endTime = dayjs(this.dataItem.endTimestamp)
          }
          this.getTrackVideos()
          this.playTime = this.startTime
          this.calcTrack()
        }
      } else {
        // 异常处理，当没有开始时间时，默认使用当前时间，防止界面报错
        this.startTime = dayjs(new Date())
        this.endTime = this.startTime
        this.playTime = this.startTime
        this.calcTrack()
      }
    },
    // 计算轨迹-定时任务处理
    calcTrack() {
      if (this.playInterval) {
        this.clearPlayInterval()
      }
      this.gpsTemp = []
      // 设置播放按钮是否处于播完状态
      if (this.playTime < this.endTime) {
        this.playing = true
      } else {
        this.playing = false
      }
      this.playInterval = setInterval(() => {
        // 2分钟 * 倍率 / 秒
        this.playTime = this.playTime.add(this.setSpeedTime * this.speed, 'seconds')
        if (this.playTime > this.endTime) {
          // 播放结束
          this.percent = 100
          this.playing = false
          this.playTime = this.endTime
          this.clearPlayInterval()
        } else {
          // 计算播放百分比
          this.percent = (100 * (this.playTime - this.startTime)) / (this.endTime - this.startTime)
          if (this.excludeList.length > 0) {
            for (let item of this.excludeList) {
              let videoStartTime = dayjs(item.startTimestamp)
              let videoEndTime = dayjs(item.endTimestamp)
              if (this.playTime >= videoStartTime && this.playTime <= videoEndTime) {
                let dayjsPlay = dayjs(this.playTime).format('YYYY-MM-DD HH:mm:ss')
                let dayjsItem = dayjs(videoStartTime).format('YYYY-MM-DD HH:mm:ss')

                this.secondTime = timeFilter(dayjsItem, dayjsPlay)
                this.hasVideo = true
                this.videoData = item
                break
              } else {
                this.hasVideo = false
              }
            }
          }
        }
        // 绘制开始事件
        if (this.drawPointIndex === 0) {
          // 触发父组件绘制开始事件
          this.$emit('drawTrackStart')
        }
        if (this.currentTrackPoints.length === 0) {
          // 当不存在轨迹时，不进行后续的绘制
          return
        }
        // 计算当前时间段轨迹 从已绘制的index开始
        for (var i = this.drawPointIndex + 1; i <= this.currentTrackPoints.length - 1; i++) {
          const gpsTrace = this.currentTrackPoints[i]
          let time = gpsTrace.timestamp || gpsTrace.logTimestamp
          if (time && this.playTime >= dayjs(time)) {
            this.drawPointIndex = i
            this.drawNextPoint()
          } else {
            break
          }
        }
        // 绘制头盔在轨迹的最新位置
        this.addCurrent(this.currentTrackPoints[this.drawPointIndex])
        // 检查最后一个点位置，判断是否需要进行自动居中调整
        this.checkPointInScreen(this.currentTrackPoints[this.drawPointIndex])
      }, this.setInterTime)
      // 退出前清空定时器
      this.$once('hook:beforeDestroy', () => {
        this.clearPlayInterval()
      })
    },
    // 绘制轨迹下一个点
    drawNextPoint() {
      let currentPoint = this.currentTrackPoints[this.drawPointIndex]
      if (currentPoint) {
        this.calcLineStyle(this.currentTrackPoints[this.drawPointIndex - 1], currentPoint)
        if (currentLine) {
          currentLine.appendCoordinate(transformatPoint(currentPoint))
        }
      }
    },
    // 计算绘制轨迹线的样式
    calcLineStyle(point1, point2) {
      if (!vectorTrackLayer) {
        return
      }
      let distance = getDistance([point2.lng, point2.lat], [point1.lng, point1.lat])
      // 计算两点经纬度之间的时间（秒）
      let time = (new Date(point2.logTimestamp) - new Date(point1.logTimestamp)) / 1000
      // 计算计算两点经纬度的平均速度
      let velocity = distance / time
      // 通过速度判断轨迹颜色
      let color
      if (velocity <= 6) {
        // 每秒小于6米，展示为绿色实线
        color = '#00f2a9'
      } else if (velocity < 16.7) {
        // 每秒6-16.7米，展示为黄色
        color = '#ffdd3e'
      } else {
        // 每秒大于16.7米 = 每小时60公里，展示为橙色
        color = '#ff762b'
      }
      // 线框与线同色
      let strokeStyle
      // locationType 是否为GPS，gps：实线，否：虚线，粉色
      if (point2.locationType == 0) {
        strokeStyle = 'solid'
      } else {
        strokeStyle = 'dashed'
        color = '#da69fa'
      }
      let style = strokeStyle + color
      if (style !== currentLineStyle) {
        let transPoint = transformatPoint(point1)
        currentLine = new LineString([transPoint])
        console.log(`new LineString style：${style} point:${transPoint}`)
        var lineFeayure = new Feature({
          geometry: currentLine,
        })
        lineFeayure.setStyle(
          new Style({
            stroke: new Stroke({
              width: 3,
              color: color,
              lineDash: strokeStyle === 'dashed' ? [8, 7] : null,
            }),
          })
        )
        vectorTrackLayer.getSource().addFeature(lineFeayure)
        currentLineStyle = style
      }
      // 关键点绘制,每7个点绘制一个关键点
      if (this.drawPointIndex % 7 === 0) {
        let transPoint = transformatPoint(point1)
        let pointFeayure = new Feature({
          // 点击事件通过type触发
          type: 'trackpoint',
          geometry: new Point(transPoint),
        })
        // 事件需要使用的参数
        pointFeayure.setProperties({ lng: transPoint[0], lat: transPoint[1] ,logTimestamp:point1.logTimestamp})
        pointFeayure.setStyle(
          new Style({
            // 点样式
            image: new CircleStyle({
              radius: 3,
              fill: new Fill({
                color: '#ffffff',
              }),
              stroke: new Stroke({
                color,
                width: 3,
              }),
            }),
          })
        )
        vectorTrackLayer.getSource().addFeature(pointFeayure)
      }
    },
    // 绘制当前头盔位置点
    addCurrent(point) {
      if (currentHelmetLayer && point) {
        currentHelmetLayer.getSource().clear()
        if (this.dataItem.helmetId && this.dataItem.helmetId.includes('ZFY')) {
          addHelmet(
            currentHelmetLayer,
            { longitude: point.lng, latitude: point.lat },
            require('@/icon/monitor/map/map-low-on-night.png')
          )
        } else {
          addHelmet(
            currentHelmetLayer,
            { longitude: point.lng, latitude: point.lat },
            require('@/icon/monitor/currentHelmet.png')
          )
        }
      }
    },
    // 通过接口获取当前轨迹数据
    async getCurrentTrackPoints(callback) {
      let trailDetail = this.listTrack[this.listTrackIndex]
      if (
        (trailDetail.userId && trailDetail.logId) ||
        trailDetail.specType === 1 ||
        trailDetail.specType === 2 ||
        trailDetail.specType === 3
      ) {
        let logids = trailDetail.logId ? trailDetail.logId : trailDetail.group
        await listGpsDetail(trailDetail.userId, logids).then(res => {
          this.currentTrackPoints = res.value ? res.value.gpsTraceDatas : []
          this.dataItem = res.value ? res.value : {}
          callback()
        })
        // 根据deviceId判断是否为jls轨迹
      } else if (trailDetail.deviceId || trailDetail.specType === 4 || trailDetail.specType === 0) {
        let param = {
          deviceName: trailDetail.deviceName,
          endTime: trailDetail.endTime,
          startTime: trailDetail.beginTime,
        }
        await traceLocation(param).then(res => {
          this.currentTrackPoints = res.data || []
          // 轨迹坐标字符串转数字
          if (this.currentTrackPoints) {
            for (let i = 0; i < this.currentTrackPoints.length; i++) {
              let e = this.currentTrackPoints[i]
              e.lat = Number(e.latitude)
              e.lng = Number(e.longitude)
              // 轨迹的采集方式设置为GPS
              e.locationType = 0
              // 轨迹的采集时间设置为与其它设备兼容的时间
              e.logTimestamp = e.timestamp
            }
          }
          callback()
        })
      }
    },
    /**
     * 移除预加载轨迹、轨迹、设备当前位置 图层数据
     * @param {Boolean} clearPreLayer 是否清除预加载轨迹 图层数据
     */
    clearLayers(clearPreLayer) {
      // 清除预加载轨迹 图层
      if (clearPreLayer && vectorPreLayer) {
        vectorPreLayer.getSource().clear()
      }
      // 清除绘制轨迹 图层
      if (vectorTrackLayer) {
        vectorTrackLayer.getSource().clear()
      }
      // 清除头盔最新位置图标 图层
      if (currentHelmetLayer) {
        currentHelmetLayer.getSource().clear()
      }
    },
    // 重置地图属性
    resetMapAttr() {
      this.drawPointIndex = 0
      currentLineStyle = ''
    },
    // **** 视频处理相关 ****
    // 获取普通视频列表
    getTrackVideos() {
      let param = {
        userId: this.item.userId || this.listTrack[0].userId,
        logTimestampBegin: this.logTimesBegin,
        logTimestampEnd: this.logTimesEnd,
        pageSize: 200,
        pageNum: 1,
        importantFlag: false,
      }
      listMediasTag(param).then(res => {
        this.videoList = res.value.list
        this.getTrailImpVideos()
      })
    },
    // 获取重要视频列表
    getTrailImpVideos() {
      let param = {
        userId: this.item.userId || this.listTrack[0].userId,
        logTimestampBegin: this.logTimesBegin,
        logTimestampEnd: this.logTimesEnd,
        pageSize: 200,
        pageNum: 1,
        importantFlag: true,
      }
      listMediasTag(param).then(res => {
        this.videoList.push(res.value.list)
        this.excludeList = []
        this.videoList.map(item => {
          if (item.status !== 1 && item.uploadFlag === true) {
            this.excludeList.push(item)
          }
        })
      })
    },
    // 轨迹的录像播放
    playVideo() {
      this.hasPlay = true
      this.$emit('openTrackVideo', this.videoData, this.hasPlay, this.secondTime)
      this.pause()
    },
    // 检查播放最后一个点是否在屏幕范围内，若不在则将该点重新设为中心点
    checkPointInScreen(point) {
      if (!point || !point.lng) {
        return
      }
      // 获取地图中心点
      let extents = map.getView().calculateExtent()
      if (!extents) {
        return
      }
      let lngMin = extents[0]
      let latMin = extents[1]
      let lngMax = extents[2]
      let latMax = extents[3]
      // 误差范围
      let waveLng = (lngMax - lngMin) / 6
      let waveLat = (latMax - latMin) / 6
      if (
        point.lng < lngMin + waveLng ||
        point.lng > lngMax - waveLng ||
        point.lat < latMin + waveLat ||
        point.lat > latMax - waveLat
      ) {
        setMapCenter(map, point)
      }
    },
    // **** 轨迹控制器按钮控制相关 ****
    // 清空定时播放定时器
    clearPlayInterval() {
      clearInterval(this.playInterval)
      this.playInterval = null
    },
    // 重播
    refresh() {
      this.percent = 0
      this.playTime = this.startTime
      this.clearLayers()
      this.resetMapAttr()
      this.calcTrack()
    },
    // 播放上一个轨迹
    before() {
      if (this.listTrackIndex - 1 < 0) {
        this.$emit('update:listTrackIndex', 0)
        this.$nextTick(() => {
          // 此页已经播放完 查找上一页数据
          if (this.pageNum > 1) {
            this.pageNum = this.pageNum - 1
            this.searchTrailData('before')
          }
        })
      } else {
        this.$emit('update:listTrackIndex', this.listTrackIndex - 1)
        this.$nextTick(() => {
          this.init()
        })
      }
      this.$nextTick(() => {
        console.log(
          `行号：${this.listTrackIndex + 1}/${this.listTrack.length} 页号：${this.pageNum}/${this.trailTotal}`
        )
      })
    },
    // 播放下一个轨迹
    next() {
      if (this.listTrackIndex + 1 >= this.listTrack.length) {
        this.$emit('update:listTrackIndex', this.listTrack.length - 1)
        this.$nextTick(() => {
          // 此页已经播放完 查找下一页数据
          if (this.pageNum < this.trailTotal) {
            this.pageNum = this.pageNum + 1
            this.searchTrailData('next')
          }
        })
      } else {
        this.$emit('update:listTrackIndex', this.listTrackIndex + 1)
        this.$nextTick(() => {
          this.init()
        })
      }
      this.$nextTick(() => {
        console.log(
          `行号：${this.listTrackIndex + 1}/${this.listTrack.length} 页号：${this.pageNum}/${this.trailTotal}`
        )
      })
    },
    searchTrailData(type) {
      if (this.trailQuery.userId) {
        // 拼接查询条件
        let params = Object.assign(deepClone(this.trailQuery), { pageNum: this.pageNum })
        if (params.logTimestampBegin) {
          params.logTimestampBegin = formatTime(params.logTimestampBegin)
        }
        // 结束时间设置为每天最后一秒
        params.logTimestampEnd = formatDate(params.logTimestampEnd) + ' 23:59:59'

        listGps(params).then(res => {
          this.$emit('nextCloseTrail')
          let data = res.value.list || []
          this.$emit('update:listTrack', data)
          if (type === 'next') {
            this.$emit('update:listTrackIndex', 0)
          } else {
            this.$emit('update:listTrackIndex', data.length === 0 ? 0 : data.length - 1)
          }
          this.$nextTick(() => {
            this.init()
          })
        })
      }
    },
    // 点击播放
    play() {
      if (this.playTime === this.endTime) {
        // 如果已播放完成，触发重播事件
        this.refresh()
      } else {
        // 继续播放剩余轨迹
        this.calcTrack()
      }
    },
    // 点击暂停
    pause() {
      this.playing = false
      this.clearPlayInterval()
    },
    // 减速播放
    reduction() {
      this.speed = this.speed - 0.5
      if (this.speed < 0.1) {
        this.speed = 0.1
      }
    },
    // 加速播放
    quicken() {
      if (this.speed === 0.1) {
        this.speed = 0.5
      } else {
        this.speed = this.speed + 0.5
        if (this.speed > 15.0) {
          this.speed = 15.0
        }
      }
    },
    // 显示所有
    list() {
      this.percent = 99
      this.playTime = this.endTime
      this.calcTrack()
    },
    // 拖动滚动条导致百分比变动 计算当前播放时间
    percentChange(percent) {
      // 往回拖动进度条 先清理轨迹图层
      if (this.percent > percent) {
        this.clearLayers()
        this.resetMapAttr()
      }
      this.percent = percent
      this.playTime = dayjs(((this.endTime - this.startTime) * percent) / 100 + this.startTime)
      // 重置 临时轨迹
      this.gpsTemp = []
      // 重新播放
      this.calcTrack()
    },
    closeWin() {
      this.$emit('closeTrackController')
      // 复原轨迹播放
      this.$store.commit('isPlayTrack', true)
      this.$store.commit('jlsTrackList', true)
      // 更新弹窗关闭状态，后续可去除
      this.$store.commit('updatePlayTrail', false)
    },
  },
  watch: {
    showTrackVideo: {
      handler(val) {
        if (val === true) {
          this.hasPlay = false
          this.setSpeedTime = 20
          this.setInterTime = 300
          this.calcTrack()
        }
      },
      immediate: true,
    },
    trailPageNum: {
      handler(val) {
        this.pageNum = val
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    // 销毁前清空绘制资源
    this.clearLayers(true)
    // 更新弹窗关闭状态，后续可去除
    this.$store.commit('updatePlayTrail', false)
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/style/mixin.styl'
/* 新版界面覆盖样式 */
.trail-container {
  bottom: 100px;
  left: 450px;
}
.sys-close-btn:after
  font-size 24px

/* 深色模式样式覆盖 */
.theme-dark
  .help_icon
    bg-image('~@/icon/help.png')

/* 新旧版通用样式 */
.trail-container {
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: 410px;
  height: 170px;
  box-sizing: border-box;
  box-shadow: 8px 0px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 20px;
  z-index: 10;
}
.header {
  line-height: 18px;
  display: flex;
  justify-content: space-between;
}
.trail-title {
  font-size: 18px;
  font-weight: bold;
  color #222
}
.close-btn {
  cursor: pointer;
  width: 16px;
  height: 16px;
}
.main {
  margin-top: 20px;
  position: relative;
}
.play-time {
  position: absolute;
  top: 3px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  pointer-events: none;
  color: #333;
}
.desc {
  display: flex;
  justify-content: space-between;
  line-height: 25px;
}
.start {
  font-size: 10px;
}
.speed {
  font-size: 10px;
}
.end {
  font-size: 10px;
  align-self: start;
}
.btn-group {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  color: #fff;

  cursor: pointer;
  padding: 0;
}
.btn img {
  width: 16px;
  height: 16px;
}
.disab-btn {
  background-color: #a9a9a9;
  border-color: #a9a9a9;
}
.allow-btn {
  background-color: #2162f6;
  border-color: #2162f6;
}
.video-btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  padding: 0;
}
.video-btn img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
}
.el-button .is-disabled,
.el-button.is-disabled:hover {
  background-color: #a9a9a9 !important;
}
.help_icon
  display inline-block
  width 16px
  height 16px
  float right
  margin 2px 4px
  bg-image('~@/icon/newBg/help_icon.png')
.external
  bottom: 100px;
  left: 50px;
  width: 310px;/*no*/
  height: 130px;/*no*/
  border-radius: 0.02083333rem;/*no*/
  padding: 15px;/*no*/
  .sys-close-btn:after
    font-size 14px
  .header
    line-height: 14px;/*no*/
    .trail-title
      font-size: 14px;/*no*/
  .main
    margin-top: 5px;/*no*/
  .desc
    line-height: 25px;/*no*/
  .btn-group
    margin-top: 5px;/*no*/
  .btn
    width: 24px;/*no*/
    height: 24px;/*no*/
    padding: 7px!important;/*no*/
    img
      width: 14px;/*no*/
      height: 14px;/*no*/
.theme-dark
  .trail-title
    color #fff
</style>
